import { Link, useHistory } from "react-router-dom";
import React from "react";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import dayjs from "@/lib/helpers/dayjs";
import images from "@/utils/images";

export function UpcomingCallCard({ nextCall: call }) {
  const history = useHistory();

  if (!call) return <NoUpcomingCall />;

  let shortUsername = call.patient_name;

  if (shortUsername.includes(" ")) {
    shortUsername = shortUsername.substr(0, shortUsername.indexOf(" "));
  }

  const isVideoCallActive = Date.now() >= dayjs(call.timestamp, "HH:mm").valueOf();
  const videoUrl = "/app/video-call?callId=" + call.callId;
  const nextCall = {
    callId: call.callId,
    callTime: call.timestamp,
    fullUserName: call.patient_name,
    isVideoCallActive,
    LocalTime: dayjs(call.timestamp, "HH:mm").format("hh:mm A"),
    patient_name: call.patient_name,
    patient_username: call.patient_username,
    shortUsername,
    videoUrl,
  };

  return (
    <DashboardCard2 className="tw:justify-between" rawChildren>
      <div
        className="cursorOnMobile tw:flex tw:items-start tw:justify-between"
        onClick={() => (window.innerWidth < 992 ? history.push(nextCall.videoUrl) : null)}
      >
        <p className="fs-30 fs-xl-50 mb-0 tw:font-bold" data-public>
          {nextCall.LocalTime}
        </p>

        <img
          alt="calendar icon"
          className="d-none d-md-block"
          src={images("./provider/calendar_icon.svg")}
        />
      </div>

      <div className="d-flex align-items-center justify-content-between">
        <p className="CardText fs-lg-16 fs-13">
          Upcoming Video Call with{" "}
          <strong className="text-break" data-private>
            {nextCall.patient_name}
          </strong>
        </p>

        <Link disabled={!nextCall.isVideoCallActive} to={nextCall.videoUrl}>
          <img alt="start call icon" src={images("./provider/start_call_chevron.svg")} />
        </Link>
      </div>
    </DashboardCard2>
  );
}

function NoUpcomingCall() {
  return (
    <DashboardCard2 className="DashboardViewCard py-2 px-3 px-lg-4">
      <div className="tw:float-right">
        <img
          alt="calendar icon"
          className="d-none d-md-block mt-2 mb-2 pt-1 pb-1"
          src={images("./provider/calendar_icon.svg")}
        />
      </div>

      <div className="d-flex align-items-center justify-content-between">
        <p className="CardText fs-lg-16 fs-13 mt-3">No Upcoming Video Calls</p>
      </div>
    </DashboardCard2>
  );
}
